<template>
  <Header />
  <div class="personal-info-activation-wrapper">
    <!-- col starts here -->
    <div class="container">
      <div class="row my-4">
        <div class="col-lg-5">
          <div class="bg-white py-3 px-3 rounded-4"></div>
        </div>
        <div class="col-lg-7">
          <div class="personal-info-col bg-white py-3 px-3 rounded-4">
            <div class="form-container-row-personal-info">
              <h2>Add a Username</h2>
              <p>
                If you'd like to, you can add a username to help other users identify you.
                Your username will be used in place of your profile name in family
                networks, and is what anyone else will see when viewing your profile. It's
                entirely optional and you can update, add, or delete your username at any
                time from your profile settings.
              </p>

              <form class="personal-form-row">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label text-left"
                    >Username</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Username"
                  />
                </div>

                <button class="activate-kit-cta btn btn-primary w-100 mt-0">Save</button>
                <p class="no-choice mt-2"><a href="">No thank you</a></p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- col ends here -->
  </div>
</template>
<script setup>
import Header from "@/components/header/Header.vue";

import "../../styles/pages/Activation.scss";
</script>
